<template>
  <div>
    <v-tabs v-model="tabs" dark dense class="rounded-lg" background-color="primary" active-class="tab-active"
      slider-color="#ffbc00">
      <v-tab> Registrar asistencias </v-tab>
      <v-tab> Historial de asistencias </v-tab>
    </v-tabs>
    <v-tabs-items touchless v-model="tabs">
      <v-tab-item class="py-4">
        <RegistroAsistencias />
      </v-tab-item>
      <v-tab-item class="py-4">
        <HistorialAsistenciaColegio />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import RegistroAsistencias from "./components/RegistrarAsistenciaColegio.vue";
import HistorialAsistenciaColegio from "./components/HistorialAsistenciaColegio.vue";

export default {
  components: {
    RegistroAsistencias,
    HistorialAsistenciaColegio
  },

  data() {
    return {
      tabs: 0,
    }
  }
}
</script>
